import React from "react";

export default function ProcessSteps({ dark = false }) {
  const STEPS = [
    {
      n: "01",
      title: "Request a Consultation",
      body: "Submit the form or call. Tell us a bit about the property and what you need.",
    },
    {
      n: "02",
      title: "Project Review",
      body: "We review the property, goals, timeline, and scope — on site or by call.",
    },
    {
      n: "03",
      title: "Estimate & Planning",
      body: "You get a practical estimate, next steps, and a clear scheduling picture.",
    },
    {
      n: "04",
      title: "Construction or Maintenance Begins",
      body: "We coordinate the trades, communicate clearly, and focus on quality.",
    },
    {
      n: "05",
      title: "Follow-Up & Long-Term Support",
      body: "Stay with us for future projects, maintenance plans, and ongoing care.",
    },
  ];
  return (
    <div className="grid md:grid-cols-5 gap-4" data-testid="process-steps">
      {STEPS.map((s) => (
        <div key={s.n} className={`p-5 rounded-md border ${dark ? "border-br-line bg-br-charcoal text-white" : "border-gray-200 bg-white"}`}>
          <div className="font-display text-3xl text-br-bronze tracking-wider">{s.n}</div>
          <div className="divider-bronze my-2" />
          <h4 className={`font-display tracking-wider uppercase text-sm mb-1 ${dark ? "text-white" : "text-gray-900"}`}>{s.title}</h4>
          <p className={`text-xs leading-relaxed ${dark ? "text-gray-300" : "text-gray-600"}`}>{s.body}</p>
        </div>
      ))}
    </div>
  );
}
